<template>
	<el-row>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down left-triangle">
			</div>
		</el-col>
		<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
			&nbsp;
		</el-col>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down right-triangle"></div>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		name: 'Decoration',
		props: ['data']
	}
</script>

<style>
	@media (min-width:992px) {
		.left-triangle {
			width: 0;
			height: 0;
			border-right: 360px solid transparent;
			border-bottom: 70px solid #eaf2f9;
		}
		.right-triangle {
			width: 0;
			height: 0;
			border-left: 360px solid transparent;
			border-bottom: 70px solid #eaf2f9;
		}
	}

	@media (max-width:992px) {}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Decoration.vue